export const ERROR = {
    MAX_FORGOT_ACCOUNT: 'exceed limit forgot password request for account',
    MAX_FORGOT_DEVICE: 'exceed limit forgot password request for device',
    NO_EMAIL: "HAVEN'T EMAIL",
    EMAIL_EXISTED: "EMAIL_EXISTED"
}